import { useEffect } from "react";
import ImageGeneric from "@/assets/images/lg.png";

interface NotificationBalloonProps {
  message: string;
  senderName: string;
  senderImage: string;
  onClose: () => void;
}

export function NotificationBalloon({
  message,
  senderName,
  senderImage,
  onClose,
}: NotificationBalloonProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="fixed top-16 right-4 md:bottom-10 md:right-10 md:top-auto bg-azul-300 md:bg-azul-400 text-white p-3 rounded-lg shadow-lg flex items-center gap-2 z-50">
      <div className="flex items-start gap-2 max-w-72 w-full">
        <img
          src={senderImage ?? ImageGeneric}
          alt={senderName || "Usuário"}
          className="w-8 h-8 rounded-full object-cover"
        />
        <div className="flex flex-col">
          <span className="font-bold text-sm">{senderName}</span>
          <span className="text-sm line-clamp-2 overflow-hidden text-ellipsis">
            {message}
          </span>
        </div>
      </div>
    </div>
  );
}
